import baseRequest from './baseRequest';

export function submit(values: LoanEstimate) {
  return baseRequest.post('/api/loan-estimate-requests', values);
}
